import getReport from './helpers.js';

export function DiffReport(props) {
    const { diff, options } = props;
    const reportHtml = getReport(diff, options);
    const reportMarkup = { __html: reportHtml };
    return <div className="w-full flex flex-col gap-2" dangerouslySetInnerHTML={reportMarkup} />;
}
